import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import useMeasure from 'use-measure';
import styled from 'styled-components/macro';

const VerticalExpand = ({ children, open }) => {
  const ref = useRef(null);
  const { height } = useMeasure(ref);

  return (
    <VerticalExpandContainer
      variants={{
        open: { height },
        closed: { height: 0 },
      }}
      initial="closed"
      animate={open ? 'open' : 'closed'}
    >
      {React.cloneElement(children, { ref })}
    </VerticalExpandContainer>
  );
};

const VerticalExpandContainer = styled(motion.div)`
  overflow-y: hidden;
`;

export default VerticalExpand;
